import config from 'config/index';
import type { Country } from 'services/i18n';
import { rumService } from 'services/rum';

import type { Activity } from '../activities';

type GetPopularActivitiesParams = {
  country: Country;
  quantity?: number;
};

export async function getPopularActivities({
  country = 'us',
  quantity = 10,
}: GetPopularActivitiesParams) {
  const url = `${
    config.PARTNERS_SELF_SIGNUP_BFF_URL
  }/v1/activities/popular?country=${country.toUpperCase()}&quantity=${quantity}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      rumService.addError(
        new Error(
          `[getPopularActivities] ${response.status} (${response.statusText})`,
        ),
      );
      return [];
    }

    const result: Activity[] = await response.json();

    return result;
  } catch (error) {
    rumService.addError(
      new Error(`[getPopularActivities] ${(error as Error).message} `),
    );
    return [];
  }
}

export function getPopularActivitiesQueryOptions({
  country = 'us',
  quantity = 10,
}: GetPopularActivitiesParams) {
  return {
    queryKey: ['popular-activities', country, quantity],
    queryFn: () =>
      getPopularActivities({
        country,
        quantity,
      }),
    refetchOnMount: false,
  };
}
